import React, { useEffect, useState } from "react";
import { CreateUserProps, SelectOption, UserFormState } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/pages/UsersPage/type/UsersPage.type";
import { createUser, updateUser } from "../../../resources/helper/userHelper";
import { ICreateUser, UserInterface } from "../types/types";
import { getClient } from "../../../resources/helper/helper";
import LocalStorageService from "../../../services/localStorage";
import { useBranchesGetAll } from "../../../fnx/branches/branchesGetAll";
import { useIdentificationTypeGetAll } from "../../../fnx/identificationType/identificationTypeGetAll";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useForm, UseFormReturn } from "react-hook-form";

interface UseCreateUserFormProps {
	openDrawer: boolean;
	setOpenDrawer: (openDrawer: boolean) => void;
	onSubmit: () => void;
	idTypeOptions: CreateUserProps["idTypeOptions"];
	genderOptions: CreateUserProps["genderOptions"];
	companyOptions: CreateUserProps["companyOptions"];
	branchOptions: CreateUserProps["branchOptions"];
	intermediaryOptions: CreateUserProps["intermediaryOptions"];
	loadingCreateUser: boolean;
	formCreateUser: UseFormReturn<UserFormState>;
	selectedUser: UserInterface | null;
	setSelectedUser: (user: UserInterface | null) => void;
	isEditing: boolean;
}

const genderOptions: SelectOption[] = [
	{
		id: "M",
		name: "Masculino",
		label: "Masculino",
		value: "M",
	},
	{
		id: "F",
		name: "Femenino",
		label: "Femenino",
		value: "F",
	},
];
const intermediaryOptions: SelectOption[] = [
	{
		id: "1",
		name: "Intermediario 1",
		label: "Intermediario 1",
		value: "1",
	},
];

const storageKey2 = "afy-login";
const lsLogin = new LocalStorageService(storageKey2);

type SeeToast = {
	show: boolean;
	type: typeAlert;
	message: string;
};

export const useCreateUserForm = (
	setSeeToast: (seeToast: SeeToast) => void
): UseCreateUserFormProps => {
	const [openDrawer, setOpenDrawer] = useState(false);
	const [selectedUser, setSelectedUser] = useState<UserInterface | null>(null);
	const formCreateUser = useForm<UserFormState>({
		mode: "onChange",
		defaultValues: {
			firstName: "",
			lastName: "",
			birthDate: "",
			idType: "",
			idNumber: "",
			gender: "",
			username: "",
			email: "",
			password: "",
			confirmPassword: "",
			company: "",
			branch: "",
			intermediary: "",
		},
	});
	const [clients, setClients] = useState<SelectOption[]>([]);
	const [identificationTypes, setIdentificationTypes] = useState<SelectOption[]>([]);
	const [branches, setBranches] = useState<SelectOption[]>([]);
	const [loadingCreateUser, setLoadingCreateUser] = useState(false);
	const [clientId] = React.useState<string>(
		lsLogin.getUserLoginStored().clientId
	);
	const [branchId] = React.useState<string>(
		lsLogin.getUserLoginStored().branchId
	);
	useEffect(() => {
		const fetchClients = async () => {
			const response = await getClient(true, 1, 10);

			if (response?.data) {
			setClients(
				response?.data?.map((client: any) => ({
					id: client.id,
					name: client.description,
					label: client.description,
					value: client.id,
				}))
			);
			}
		};
		fetchClients();
	}, []);

	const { responseBranches, errorBranches, loadingBranches } =
		useBranchesGetAll(true, clientId, "", "");
	const {
		responseIdentificationType,
		errorIdentificationType,
		loadingIdentificationType,
	} = useIdentificationTypeGetAll(true, "", "", 1, 20);

	useEffect(() => {
		if (responseIdentificationType && responseIdentificationType?.data) {
			setIdentificationTypes(
				responseIdentificationType?.data?.map((item: any) => ({
					id: item.code,
					name: item.description,
					label: item.description,
					value: item.code,
				}))
			);
		}
	}, [responseIdentificationType]);

	useEffect(() => {
		if (responseBranches && responseBranches?.length > 0) {
			console.log("responseBranches", responseBranches);
			setBranches(
				responseBranches?.map((item: any) => ({
					id: item.id,
					name: item.name,
					label: item.name,
					value: item.id,
				}))
			);
		}
	}, [responseBranches]);

	// Efecto para cargar los datos del usuario seleccionado en el formulario
	useEffect(() => {
		if (selectedUser) {
			formCreateUser.reset({
				firstName: selectedUser.name,
				lastName: selectedUser.lastName,
				email: selectedUser.email,
				username: selectedUser.userName,
				company: selectedUser.clientId,
				branch: selectedUser.branchId,
				// Los demás campos se pueden agregar según necesidad
			});
		}
	}, [selectedUser]);

	const onSubmit = async () => {
		const values = formCreateUser.getValues();
		const user: ICreateUser = {
			name: values.firstName,
			lastName: values.lastName,
			email: values.email,
			password: values.password,
			passwordConfirm: values.confirmPassword,
			clientId: values.company,
			branchId: values.branch,
		};

		try {
			setLoadingCreateUser(true);
			let response;
			
			if (selectedUser) {
				// Si hay un usuario seleccionado, actualizamos
				response = await updateUser(selectedUser.id, user);
			} else {
				// Si no hay usuario seleccionado, creamos uno nuevo
				response = await createUser(user);
			}
			console.log("response", response);
			if (response?.ok) {
				setSeeToast({
					show: true,
					type: typeAlert.success,
					message: selectedUser ? "Usuario actualizado correctamente" : "Usuario creado correctamente",
				});
				setOpenDrawer(false);
				setSelectedUser(null);
			} else {
				setSeeToast({
					show: true,
					type: typeAlert.error,
					message: selectedUser ? "Error al actualizar el usuario" : "Error al crear el usuario",
				});
			}
		} catch (error) {
			setSeeToast({
				show: true,
				type: typeAlert.error,
				message: selectedUser ? "Error al actualizar el usuario" : "Error al crear el usuario",
			});
		} finally {
			setLoadingCreateUser(false);
		}
	};

	return {
		openDrawer,
		setOpenDrawer,
		onSubmit,
		idTypeOptions: identificationTypes,
		genderOptions,
		companyOptions: clients,
		branchOptions: branches,
		intermediaryOptions,
		loadingCreateUser,
		formCreateUser,
		selectedUser,
		setSelectedUser,
		isEditing: !!selectedUser
	};
};
